import AuthAccess from "src/data/auth/authAccess/AuthAccess";
import PropTypes from "prop-types";
import AddrTyomaa from "./AddrTyomaa";
import { useUserData } from "src/context/userContext";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { tyomaa_fetch } from "src/data/tyomaa/tyomaaFunctions";
import ProgressCirc from "src/components/layout/Progress/ProgressCirc";

export default function AddrTyomaaCore({ keikkaId = null }) {
  const { user, token, ownerAsiakasId, userAsiakas } = useUserData();
  const [tyomaa, setTyomaa] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  let params = useParams();
  let tyomaaId = parseInt(params.tyomaaId);

  useEffect(() => {
    const asyncFunc = async () => {
      if (tyomaaId) {
        const fetchResult = await tyomaa_fetch(user.personId, tyomaaId, token, keikkaId);
        const _tyomaa = fetchResult.globalTyomaa;
        if (_tyomaa != null) {
          setTyomaa(_tyomaa);
        } else {
          setIsError(true);
        }
      } else setTyomaa(null);
      setIsLoading(false);
    };
    asyncFunc();
  }, [tyomaaId, ownerAsiakasId]);

  if (isError) return <>isError</>;
  if (isLoading) return <ProgressCirc />;

  return (
    <AuthAccess tyomaa={tyomaa} user={user} userAsiakas={userAsiakas} showError>
      <AddrTyomaa tyomaa={tyomaa} keikkaId={keikkaId} />
    </AuthAccess>
  );
}

AddrTyomaaCore.propTypes = {
  keikkaId: PropTypes.number,
};
